export interface Quote {
	id: string;
	text: string;
	author: string;
	imageUrl?: string;
	source?: string; // 'cybercore' | 'scifi' | 'custom'
}

export const defaultQuote = (): Quote => ({
	id: '',
	text: '',
	author: '',
	imageUrl: '',
	source: 'custom',
});
